// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"5805fc43","667":"187cc40d","977":"f664814b"}[chunkId] + ".chunk.js";
};